import { render, staticRenderFns } from "./SubmitForApprovalModal.vue?vue&type=template&id=65c77dde&scoped=true"
import script from "./SubmitForApprovalModal.vue?vue&type=script&lang=js"
export * from "./SubmitForApprovalModal.vue?vue&type=script&lang=js"
import style0 from "./SubmitForApprovalModal.vue?vue&type=style&index=0&id=65c77dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c77dde",
  null
  
)

export default component.exports